/* eslint-disable prefer-arrow-callback */
import { ErrorMessage } from 'formik';
import React from 'react';
import Select from 'react-select';
import { FormGroup, Label } from 'reactstrap';
// import { ErrorMessage } from "formik";

const ReactSelect = (props) => {
  const {
    data = [],
    form: { setFieldValue, errors, touched, setFieldTouched },
    field: { name, value: fieldValue, ...fields },
    keys,
    required,
    isDisabled = false,
    onChange: externalOnChange,
    value: passedValue,
    ...rest
  } = props;

  const isMulti = Boolean(rest.isMulti);

  const getOptionKey = (option) => option?.id ?? option?.value ?? '';

  const resolveOption = (value) => {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (isMulti && Array.isArray(value)) {
      return value.map((item) => resolveOption(item)).filter(Boolean);
    }

    if (typeof value === 'object') {
      const valueKey = getOptionKey(value);

      if (valueKey !== '' && Array.isArray(data)) {
        const matchedOption = data.find(
          (option) => String(getOptionKey(option)) === String(valueKey),
        );

        if (matchedOption) {
          return matchedOption;
        }
      }

      return value;
    }

    if (Array.isArray(data)) {
      const matchedOption = data.find(
        (option) =>
          String(getOptionKey(option)) === String(value) ||
          String(option?.label ?? '') === String(value),
      );

      return matchedOption || null;
    }

    return null;
  };

  const handleChange = (newValue, actionMeta) => {
    setFieldValue(name, newValue, true);
    if (typeof externalOnChange === 'function') {
      externalOnChange(newValue, actionMeta);
    }
  };
  const handleBlur = () => {
    setFieldTouched(name);
  };
  const selectedValue = passedValue === undefined ? fieldValue : passedValue;
  const value = resolveOption(selectedValue);
  const styles = {
    control: (base) => ({
      ...base,
      fontSize: '14px',
    }),
    menu: (base) => ({
      ...base,
      fontSize: '13px',
    }),
  };

  return (
    <FormGroup className="flex-grow-1">
      {rest.label && (
        <Label
          for={rest.id}
          className={`label-color ${isDisabled ? 'disabled' : ''}`}
        >
          {rest.label}
          {required && <span className="text-danger">*</span>}
        </Label>
      )}
      <div className={errors[name] && touched[name] && 'select-error'}>
        <Select
          {...fields}
          id={name}
          blurInputOnSelect={false}
          onBlur={handleBlur}
          value={value}
          options={data}
          onChange={handleChange}
          getOptionValue={(option) => String(getOptionKey(option))}
          getOptionLabel={(option) => option?.name || option?.label || ''}
          styles={styles}
          classNamePrefix="react-select"
          isDisabled={isDisabled}
          {...rest}
        />
      </div>
      {/* {errors[name] && touched[name] && (
        <div className="text-danger f-12">{errors[name]}</div>
      )} */}
      {/* {errors[name] && touched[name] && (
        <div className="text-danger f-12">{errors[name]?.id}</div>
      )} */}
      <ErrorMessage
        name={name}
        render={(msg) => {
          return <div className="text-danger f-12 text-nowrap">{msg}</div>;
        }}
      />
    </FormGroup>
  );
};

export default ReactSelect;
